module.exports = __webpack_public_path__ + "img/icon_tupian.8845e150.svg";